export function initializeMobileMenu() {
    const OPEN_CLASSNAME = 'mobile-click'

    const HeaderOverlay = document.querySelector("div.header-overlay") 
    const menuItems = [...HeaderOverlay.querySelectorAll("div.header-menu-item.children > a")]

    if (!HeaderOverlay) { 
        return
    }

    function closeAll() {
        const openItems = [...HeaderOverlay.querySelectorAll(`div.header-menu-item.${OPEN_CLASSNAME}`)]
        for (const openItem of openItems) {
            openItem.classList.remove(OPEN_CLASSNAME)
        }
    }  

    for (const item of menuItems) {
        if (!item.querySelectorAll("ul")) {
            console.log("a")
            continue
        }
    
        item.addEventListener("click", function (event) {
            if (!this.classList.contains(OPEN_CLASSNAME)) {
                event.preventDefault()

                event.stopPropagation()
                

                closeAll()
                this.classList.add(OPEN_CLASSNAME)
            }
        })
    }

    document.body.addEventListener("click", (event) => { 
        let node = event.target
        while (node) { 
            if (node.classList && node.classList.contains('div.header-menu-item')) { 
                return
            }
            node = node.parentNode
        }
        closeAll()
    })
}